import Loadable from 'react-loadable';

export const InterviewSchedulerDialog = Loadable({
  loader: () => import('./interview-scheduler-dialog'),
  loading: () => null,
});

export const HireStartDateTimeSchedulerDialog = Loadable({
  loader: () => import('./base-hire-start-date-scheduler-dialog'),
  loading: () => null,
});
